// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';
import { createPortal } from 'react-dom';
import { DecisionTreeToolbar } from './components/DecisionTreeToolbar';
import { DecisionTreeSplitPane } from './components/DecisionTreeSplitPane';
// import ResultsDisplay from '../Results/ResultsDisplay';
import ValidationModal from './ValidationModal';
import HelpModal from './HelpModal';
import type { DecisionTreeToolbarProps } from './components/DecisionTreeToolbar';
import type { DecisionTreeSplitPaneProps } from './components/DecisionTreeSplitPane';
import type { ValidationIssue } from '../../lib/validation';

export interface DecisionTreeModalsProps {
  showValidationDetails: boolean;
  onCloseValidationDetails: () => void;
  issues: ValidationIssue[];
  onIssueClick: (issue: ValidationIssue) => void;
  showHelp: boolean;
  onCloseHelp: () => void;
}

export interface DecisionTreeBuilderViewProps {
  className?: string;
  isFullscreen: boolean;
  toolbarProps: DecisionTreeToolbarProps;
  splitPaneProps: DecisionTreeSplitPaneProps;
  modalsProps: DecisionTreeModalsProps;
}

/**
 * Presentational view component for DecisionTreeBuilder
 * Composes Toolbar, SplitPane, and Modals
 */
export const DecisionTreeBuilderView: React.FC<DecisionTreeBuilderViewProps> = ({
  className,
  isFullscreen,
  toolbarProps,
  splitPaneProps,
  modalsProps,
}) => {
  const content = (
    <div className={`decision-tree-builder ${isFullscreen ? 'fullscreen' : ''} ${className || ''}`}>
      <DecisionTreeToolbar {...toolbarProps} />
      <DecisionTreeSplitPane {...splitPaneProps} />
      
      
      <ValidationModal
        isOpen={modalsProps.showValidationDetails}
        issues={modalsProps.issues}
        onClose={modalsProps.onCloseValidationDetails}
        onIssueClick={modalsProps.onIssueClick}
      />
      <HelpModal
        isOpen={modalsProps.showHelp}
        onClose={modalsProps.onCloseHelp}
      />
    </div>
  );

  // Render fullscreen version using portal
  if (isFullscreen) {
    return createPortal(content, document.body);
  }

  // Render normal version
  return content;
};

